import type React from "react";

export const EthereumTestnetIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.1285 0.900879L10.0039 1.31915V13.2105L10.1285 13.3333L15.8311 10.0031L10.1285 0.900879Z"
      fill="#FFD700"
    />
    <path
      d="M10.1285 0.900879L4.42578 10.0031L10.1285 13.3333L10.1285 7.68823V0.900879Z"
      fill="#FFEA70"
    />
    <path
      d="M10.1288 14.6459L10.0586 14.7305V19.054L10.1288 19.2566L15.8349 11.3174L10.1288 14.6459Z"
      fill="#FFC300"
    />
    <path d="M10.1285 19.2566V14.6459L4.42578 11.3174L10.1285 19.2566Z" fill="#FFEA70" />
    <path d="M10.1289 13.3333L15.8315 10.0032L10.1289 7.68799V13.3333Z" fill="#FFB300" />
    <path d="M4.42578 10.0032L10.1284 13.3333V7.68799L4.42578 10.0032Z" fill="#FFD54F" />
  </svg>
);
